import { connect } from 'react-redux';

import { getCoworkingSpecificationsSelector } from 'shared/store/coworking/selectors/smart/getCoworkingSpecificationsSelector';
import { IApplicationState } from 'shared/types/redux';

import { Specifications as SpecificationsComponent } from './Specifications';
import { TMapStateProps } from './types';

export const mapState = (state: IApplicationState): TMapStateProps => ({
  items: getCoworkingSpecificationsSelector(state),
});

export const Specifications = connect(mapState)(SpecificationsComponent);
